<template>
  <div class="news-table w-100">
    <h3 v-if="heading" class="mb-3">{{ $t(heading) }}</h3>
    <nx-table ref="tableRef" class="esh-bd-table mt-3" :rows="tableData">
      <nx-table-column
        :title="$t(titleKey)"
        data="content"
        v-slot="{ rowData }"
      >
        <span class="table-content" v-html="rowData.content" />
      </nx-table-column>
    </nx-table>
    <UFPaginationNav v-if="tableData.length" class="mt-2" :pagination="pagination" @navigate="updateList($event)" />
  </div>
</template>

<script>
import { UFPaginationNav } from '@unify/uf-pagination';

export default {
  components: {
    UFPaginationNav
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    titleKey: {
      type: String,
      required: true
    },
    fetchApi: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      pagination: {
        page: 0,
        size: 5
      }
    };
  },
  async created() {
    await this.updateList();
    setTimeout(() => $('.dataTables_empty').text(this.$t('TableNoData')), 0);
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.updateList();
      }
    }
  },
  methods: {
    async updateList(pageable) {
      let params = pageable || this.pagination;
      const { data } = await this.fetchApi({...params, language: this.$i18n.locale});
      const { content, pagination } = data
      this.tableData = content.filter(row => row.language === this.$i18n.locale);
      this.pagination = pagination;
      // 重置滚动条到顶部
      this.$nextTick(() => {
        const tableEl = this.$refs.tableRef?.$el;
        if (tableEl) {
          tableEl.scrollTop = 0;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-content ::v-deep a {
  text-decoration: underline !important;
}
.esh-bd-table {
  max-height: 400px;
  overflow-y: auto;
  position: relative;
  ::v-deep thead {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
  }
}
</style>

<i18n src="@/locales/common.locale"></i18n>
<i18n src="@/locales/components/info/InfoNewsTable.json"></i18n>
